import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/home/Banner-Who-is-your-customer.png';
import _imports_1 from '@/assets/home/Business-verification-portal.png';
import _imports_2 from '@/assets/home/Business-verification-API.png';
import _imports_3 from '@/assets/home/Customer-verification-API.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6f6f0ba0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "home"
};
var _hoisted_2 = {
  class: "banner"
};
var _hoisted_3 = {
  class: "banner-text"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "Who is your customer", -1);
});

var _hoisted_5 = {
  class: "did",
  id: "did"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "project-title animate__animated animate__fadeInUp wow"
  }, "Products We Offered ", -1);
});

var _hoisted_7 = {
  class: "item animate__animated animate__fadeInUp wow"
};
var _hoisted_8 = {
  class: "left"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Business Verification (KYB) Portal", -1);
});

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, " A platform provides you an instant business verification service to over 100+ million of business entities in different dimensions, so you can make your business decisions intelligently. ", -1);
});

var _hoisted_11 = /*#__PURE__*/_createTextVNode("LEARN MORE");

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "right"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Business Verification Portal",
    title: "Business verification Portal"
  })], -1);
});

var _hoisted_13 = {
  class: "item animate__animated animate__fadeInUp wow"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "left"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Data processing flow",
    title: "Data processing flow"
  })], -1);
});

var _hoisted_15 = {
  class: "right"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Business Verification (KYB) API", -1);
});

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, " According to your tailored requests, we can seamlessly connect you to our reliable program through API process, which provides you with more possibilities of our verification services. ", -1);
});

var _hoisted_18 = /*#__PURE__*/_createTextVNode("LEARN MORE");

var _hoisted_19 = {
  class: "item animate__animated animate__fadeInUp wow"
};
var _hoisted_20 = {
  class: "left"
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Customer Verification (KYC) API", -1);
});

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, " With the coverage of enormous identification data, we provide customized service to connect you to our program seamlessly, minimize your efforts to verify your onboard customers. ", -1);
});

var _hoisted_23 = /*#__PURE__*/_createTextVNode("LEARN MORE");

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "right"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "Customer identification success",
    title: "Customer identification success"
  })], -1);
});

var _hoisted_25 = {
  class: "testimonials"
};
var _hoisted_26 = {
  class: "testimonials-content"
};
var _hoisted_27 = ["src", "alt"];
var _hoisted_28 = {
  text: "2xl",
  justify: "center"
};
var _hoisted_29 = {
  class: "testimonials-item"
};
import Number from '@/components/Number/index.vue';
import Footer from '@/components/Footer/index.vue'; // @ is an alias to /src

import Article from '@/components/Article/index.vue'; // @ is an alias to /src

import Search from './Search';
import { onMounted, ref, getCurrentInstance, inject, reactive, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { apiGoogleLogin } from '@/api/login';
import { setToken, getToken } from '@/utils/auth';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _getCurrentInstance;

    var reload = inject('reload');
    var global = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.appContext.config.globalProperties;
    var router = useRouter();
    var numberRef = ref();
    var testimonialsData = reactive([{
      imgSrc: 'animation-group-logo.webp',
      text: "The Riscern team is knowledgeable, friendly, and always willing to go the extra mile to ensure I'm satisfied with their work.",
      alt: 'animation group logo'
    }, {
      imgSrc: 'baner-logo.webp',
      text: 'I recently worked with Riscern and was blown away by their professionalism. From start to finish, they provided exceptional service and went above and beyond to meet my needs.',
      alt: 'baner logo'
    }, {
      imgSrc: 'Fireeye-logo.webp',
      text: "Riscern's real-time company verification service has significantly helped us increase our efficiency.",
      alt: 'Fireeye logo'
    }, {
      imgSrc: 'JN-logo.webp',
      text: "Riscern's KYB API services have been a game-changer for my business. Their platform is incredibly efficient and has allowed me to speed up my onboarding process significantly.",
      alt: 'JN logo'
    }]);

    function getImg() {
      numberRef.value.play();
    }

    function onHrefPage(name) {
      router.push({
        name: name
      });
    } // function onHrefPageQuery (name: string, query: any): void{
    //   router.push({ name, query })
    // }
    // function onScrollDid () {
    //   const toElement = document.querySelector('#did')
    //   return toElement?.scrollIntoView({ behavior: 'smooth' })
    // }


    onMounted(function () {
      global.$wow.init();
      document.dispatchEvent(new Event('render-event'));
      var code = new URLSearchParams(window.location.search).get('code'); // code存在并且没登录

      if (code && !getToken()) {
        apiGoogleLogin({
          code: code
        }).then(function (_ref) {
          var data = _ref.data;
          setToken('Bearer ' + data.token);
          ElMessage.success('login success!');
          reload(); // 重置
        });
      } // 轮播按钮设置name


      nextTick(function () {
        var classDomList = document.getElementsByClassName('el-carousel__button');
        var titleList = ['First testimon', 'Second testimony', 'Third testimony', 'Fourth testimony'];

        for (var i = 0; i < classDomList.length; i++) {
          classDomList[i].setAttribute('title', titleList[i]);
        }
      });
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      var _component_el_carousel_item = _resolveComponent("el-carousel-item");

      var _component_el_carousel = _resolveComponent("el-carousel");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: _imports_0,
        alt: "Linking the World",
        title: "Linking the World",
        onLoad: _cache[0] || (_cache[0] = function ($event) {
          return getImg();
        })
      }, null, 32), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_unref(Search))])]), _createVNode(Number, {
        isShowPeople: "",
        ref_key: "numberRef",
        ref: numberRef,
        class: "animate__animated animate__fadeInUp"
      }, null, 512), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createVNode(_component_el_button, {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return onHrefPage('ProductKYBPortal');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_11];
        }),
        _: 1
      })]), _hoisted_12]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createVNode(_component_el_button, {
        class: "btn btn-right",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return onHrefPage('ProductKYBAPI');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_18];
        }),
        _: 1
      })])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _hoisted_22, _createVNode(_component_el_button, {
        class: "btn",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return onHrefPage('ProductKYCAPI');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_23];
        }),
        _: 1
      })]), _hoisted_24])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_carousel, {
        interval: 4000,
        type: "card",
        height: "200px"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(testimonialsData), function (item, index) {
            return _openBlock(), _createBlock(_component_el_carousel_item, {
              key: index
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("img", {
                  class: "testimonials-img",
                  src: require("@/assets/home/testimony/".concat(item.imgSrc)),
                  alt: item.alt
                }, null, 8, _hoisted_27), _createElementVNode("h3", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(item.text), 1)])];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      })])]), _createVNode(Article, {
        style: {
          background: '#fff'
        }
      }), _createVNode(Footer, {
        keepBg: "#FBFBFC"
      })]);
    };
  }
});